// removed by extract-text-webpack-plugin
module.exports = {"classStickyCta":"StickyCta-classStickyCta-8dd62984"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/StickyCta.scss
// module id = 882
// module chunks = 0